import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { PrimaryButton } from '../CommonComponents/Button';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { selectIsUserClient } from '../CommonSelectors/CommonAreaSelector';
import getImagePath from '../CommonUtils/getImagePath';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: 75%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

interface Props {
  clientId: string;
}

export const EMoney: React.FC<Props> = ({ clientId }) => {
  useDocumentTitle('eMoney');

  const isClient = useSelector(selectIsUserClient);

  return (
    <Wrapper>
      <img
        style={{ maxWidth: 400, width: '100%', marginBottom: 24 }}
        src={getImagePath('emoney-logo.svg')}
        alt="Group Risk"
      />

      {isClient ? (
        <PrimaryButton
          onClick={() => {
            window.open(`/Consumer/EMoney/LaunchEMoney?clientId=${clientId}`, '_blank');
          }}
        >
          Launch eMoney Portal
        </PrimaryButton>
      ) : (
        <Text color="neutral.500">Access available to client level users only.</Text>
      )}
    </Wrapper>
  );
};
